import { BasketPage as Basket } from "../../features/impact-shop/basket-page/basket-page";
import { GetServerSideProps } from "next";
import { getAuth0AccessToken } from "../../lib/auth0";
import { withLogging } from "../../lib/ssr/logGetServerSideProps";
import { prefetchImpactGroupsForSSR } from "../../features/impact-shop/hooks/useListImpactGroups";
import { createServerTRPCClient } from "../../lib/trpc/server";
import { QueryCache } from "react-query";
import { dehydrate } from "react-query/hydration";
import logger from "../../lib/logger";

export default Basket;

export const getServerSideProps: GetServerSideProps = withLogging(
  async ({ req, res }) => {
    const accessToken = await getAuth0AccessToken(req, res);

    let dehydratedState: ReturnType<typeof dehydrate> | undefined;

    if (accessToken) {
      try {
        const queryCache = new QueryCache();
        const serverTrpc = createServerTRPCClient(accessToken);

        await prefetchImpactGroupsForSSR(queryCache, serverTrpc);

        dehydratedState = dehydrate(queryCache);
      } catch (error) {
        logger.error("Failed to prefetch impact groups:", { error });
      }
    }

    return {
      props: {
        accessToken,
        ...(dehydratedState && { dehydratedState }),
        layoutProps: {
          isWhiteBody: true,
          isProfile: true,
          hideHeader: true,
        },
      },
    };
  }
);
